<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <span class="text-accent">{{ $t('Choose offer') }}</span>
      </div>
    </template>
    <TenderOffersVersionsList
      :show-all-versions="true"
      :offers="offers"
      @change-general-selected-version="(info) => $emit('change-general-selected-version', info)"
    />
  </v-menu>
</template>

<script>
  import TenderOffersVersionsList from '@/containers/tender/tender-list/TenderOffersVersionsList';
  import { VMenu } from 'vuetify/lib';

  export default {
    name: 'TenderListGeneralVersionSelector',
    components: { VMenu, TenderOffersVersionsList },
    props: {
      offers: {
        type: Array,
        required: true,
      },
    },
  };
</script>
